/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Secure/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import InApp from './InApp/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Secure({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/Secure"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let threadTypeValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: threadTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InApp'}>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}